import React from 'react';
import ItemSyncTable from '../AppGrid/ItemSyncTable';
import CommonBreadCurmb from '../components/common/CommonBreadCrumb';
import catAdminUtils from '../util/catAdminUtils';
import consts from '../consts';
import Connection from '../services/Connection';
import { usePrerequisites } from '../contexts/Prerequisites';

const ItemSync = () => {
	const [{ strings }] = usePrerequisites();
	return <CommonBreadCurmb
		docTitle={strings.ItemSync}
		breadcrumbs={[{ text: strings.ItemSync }]}
		Component={ItemSyncTable}
		handleSubmit={catAdminUtils.handleOnSubmit}
		maxCount={consts.maxScopesCount}
		message={strings.ScopesCountWarning}
		apiUrl={Connection.ItemSync}
		navigateUrl={"/itemsync"}
	/>
}

export default ItemSync;